import React,{useState,useEffect} from "react"
import style from "./newLetterEmailPopup.module.css"
import Close from "../../assets/icons8-close-24.png"
import {useSelector } from "react-redux"
import SmallLoader from "../smallLoader/SmallLoader"
import TextEditar from "../textEditar/TextEditar"
import {
    Form,
    Input,
    Radio,
    Select,
    DatePicker,
    Row,
    Spin,
    Upload,
    Col,
    Button,
    AutoComplete,
    InputNumber,
    message,
    Divider,
    TimePicker
  } from "antd"
  const { TextArea } = Input
  
const NewLetterEmailPopup=({closeHandler,label,onFinish,statusData,callBack})=>{
    const loading=useSelector((state)=>state.newsletters.deleteLoad)
    const [form] = Form.useForm()
    const onChange = (value) => {};
      const onSearch = (value) => {};
    const filterOption = (input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    const onFinishFailed = errorInfo => {}
    return (
        <>
        <div className={style.statusPopup_section}>
        <div className={style.statusPopup_section_container}>
         <div className={style.statusPopup_section_close}>
            <img src={Close} alt='close icon' onClick={closeHandler}/>
         </div>
         <div className={style.statusPopup_section_head}>{label}</div>
         <Form
            className={style.appointments_form}
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout={"vertical"}
            form={form}
            style={{
              maxWidth: "100%",
            }}
          >
            <Form.Item
              className={style.appointments_form_item}
              style={{width:"100%"}}
              label="Title"
              name="title"
              rules={[
                {
                  required: true,
                  message: "Please input your title!",
                },
              ]}
            >
            <Input placeholder="please input your title" className={style.appointments_form_select} style={{border:"1px solid #000"}}/>
            </Form.Item>
            <Form.Item
              className={style.appointments_form_item}
              style={{width:"100%"}}
              label="Content"
              name="content"
              // rules={[
              //   {
              //     required: true,
              //     message: "Please input your content!",
              //   },
              // ]}
            >
            <TextEditar callBack={callBack}/>
            {/* <TextArea rows={4} placeholder="content here...." style={{border:"1px solid #000"}}/> */}
            </Form.Item>
            <Form.Item className={style.appointments_form_submit_all}>
                  <Button
                    className={style.appointments_form_submit}
                    // type="primary"
                    htmlType="submit"
                    style={{color:"#fff"}}
                  >
                  {loading?<SmallLoader/>:'send'}
                  </Button>
                </Form.Item>
          </Form>
        </div>
        </div>
        </>
    )
}
export default NewLetterEmailPopup;